import React, { useRef, useEffect } from 'react';
import { Grid } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Form, TextField, Button } from '@curves/ui-base';
import { localUser } from '@Util/utils';
import useAuthApi from '@Apis/useAuthApi';
import { MEMBER_ROOT_ROUTER, EMPLOYEE_ROOT_ROUTER } from '@Router/routerPath';

import LoginLogo from '@Images/logo-white.svg';
import { generateTokenAuth } from '@Util/apiCryto';
import MainFooter from '@Local/Components/Footer/MainFooter';
import { MEMBER_SITE_LOGON_TYPE } from "@Constants/";

// 登入頁面
const LoginPage = () => {
    const history = useHistory();
    const { enqueueSnackbar: _snackbar } = useSnackbar();
    const { 
        postLoginApi, getLogoutApi, 
        getCheckLocalDataApi, getLocalMeDataApi, getLocalMeUiRoleApi 
    } = useAuthApi();
    const tokenKeyRef = useRef(null);
    const captchaRef = useRef(null);

    const handleLoginApi = (e) => {
        e.preventDefault();
        e.stopPropagation();
        getResult();
    };

    const getResult = () => {
        if (!tokenKeyRef.current.isError() && !captchaRef.current.isError()) {
            const token = tokenKeyRef.current.getResult();
            const pwd = captchaRef.current.getResult();
            doLoginApi(token, pwd);
        }
    };

    const doLoginApi = async (tokenKey, captcha) => {
        const { hmacSecurity, hmacKey } = generateTokenAuth(captcha);
        await postLoginApi(
            { tokenKey, captcha: hmacSecurity, hmacKey },
            {
                callbackfn: (oriData, apiData) => {
                    const { data } = apiData;
                    if (data.success) {
                        loginAction(data.result);
                    }
                },
            },
        );
    };

    const loginAction = async (result) => {
        const { displayNo = '', displayName = '', logonType } = result;
        if (displayNo !== '' && displayName !== '') {
            localUser.set(result);

            getLocalMeUiRoleApi().then((resp) => {
                if (resp) {
                    localUser.setUiRole(resp);
                }

                // 登入成功後導向原始頁面或預設頁面
                if (logonType === MEMBER_SITE_LOGON_TYPE.MEMBER) history.push(MEMBER_ROOT_ROUTER);
                else if (logonType === MEMBER_SITE_LOGON_TYPE.EMPLOYEE) history.push(EMPLOYEE_ROOT_ROUTER);
            });
        } else {
            _snackbar('驗證錯誤，請通知教練協助排解', { variant: 'error' });
            await getLogoutApi();
        }
    };

    const didLoginRef = useRef(false);
    useEffect(
        () => {
            document.body.className = 'login-page';
            const fetchData = async () => {
                let resp = await getCheckLocalDataApi();
                if (resp) {
                    // 本站已有登入態：直接用既有 session 導頁，不需再走表單送出
                    const me = await getLocalMeDataApi();
                    me && await loginAction(me);
                }
            };
            if (!didLoginRef.current) {
                // StrictMode 下 effect 會 double-invoke；此 ref 確保只檢查一次登入態
                didLoginRef.current = true;
                fetchData();
            }
            return () => {
                document.body.className = '';
            };
        },
        // eslint-disable-next-line
        [],
    );

    return (
        <React.Fragment>
            <div className="login-body">
                <div className="container">
                    <div className="logo-wrap">
                        <img src={LoginLogo} className="login-logo" alt="curves" />
                    </div>
                    <Form className="login-form" onSubmit={handleLoginApi}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <TextField ref={tokenKeyRef} label="Token" fullWidth />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField ref={captchaRef} label="驗證碼" fullWidth />
                            </Grid>
                        </Grid>
                        <div className="login-btn-confirm">
                            <Button variant="outlined" type="submit">
                                送出驗證
                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
            <MainFooter />
        </React.Fragment>
    );
};

export default LoginPage;
